import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { LocaleService } from '@shared/services/locale.service';
import { NumbersService } from '@shared/services/numbers.service';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { AuthService } from '@shared/services/auth.service';
import { ApiService } from '@shared/services/api.service';
import { SnackService } from '@shared/services/snack.service';
import { ViewportService } from '@shared/services/viewport.service';

@Component({
	selector: 'app-user-process',
	templateUrl: './user-process.component.html',
	styleUrls: ['./user-process.component.scss'],
})
export class UserProcessComponent implements OnInit {
	constructor(
		private title: Title,
		private router: Router,
		private route: ActivatedRoute,
		private api: ApiService,
		private auth: AuthService,
		private snack: SnackService,
		private numbers: NumbersService,
		public locale: LocaleService,
		public viewport: ViewportService
	) {}

	loading: boolean = false;
	subject: string;

	form: UntypedFormGroup = new UntypedFormGroup({
		altPhone: new UntypedFormControl('', Validators.required),
	});

	onKeyUp(field: string) {
		this.form.get(field).setValue(this.numbers.toNumeric(this.form.get(field).value.toString().replace(/\s/g, '')));

		if (this.form.get(field).value.toString().charAt(1) === '0') {
			this.form.get(field).setValue(this.form.get(field).value.toString().slice(0, 1) + this.form.get(field).value.toString().slice(2));
		}

		if (this.form.get(field).value.toString().charAt(0) !== '0') {
			this.form.get(field).setValue('0' + this.form.get(field).value.toString());
		}
	}

	onSubmit() {
		this.loading = true;

		const body: FormData = new FormData();
		body.append('lang', this.locale.lang);
		body.append('userID', this.auth.user()['userID']);
		body.append('type', '1');
		body.append('altPhone', this.form['value']['altPhone']);

		this.api.sendOTP(body).subscribe(
			(res) => {
				if (res['status'] === '1') {
					this.router.navigate(['/user/' + body.get('userID').toString() + '/verify'], {
						queryParams: {
							altPhone: this.form['value']['altPhone'],
						},
					});
				} else {
					this.snack.open(this.locale.translations['user']['user-process']['s23'], 10000);
				}

				this.loading = false;
			},
			(err) => {
				this.snack.open(this.locale.translations['misc']['n174'], 10000);
				this.loading = false;
			}
		);
	}

	ngOnInit(): void {
		this.title.setTitle(this.locale.translations['user']['user-process']['n241'] + ' | ' + this.locale.translations['header']['n0']);

		this.route.queryParams.subscribe((queries: Params) => {
			this.subject = queries['subject'];
		});
	}
}
